export default "__VITE_ASSET__7d60e913__"